import * as React from "react"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import { LOGO_COLLECTION } from "@/features/landing/content"

const logoStyle: React.CSSProperties = {
  height: "32px",
  opacity: 0.7,
  objectFit: "contain"
}

export default function LogoCollection() {
  return (
    <Box id="logoCollection" sx={{ py: 4 }}>
      <Typography component="p" variant="subtitle2" align="center" sx={{ color: "text.secondary" }}>
        {LOGO_COLLECTION.heading}sdsadf
      </Typography>
      <Grid container sx={{ justifyContent: "center", alignItems: "center", gap: 2, mt: 1 }}>
        {LOGO_COLLECTION.logos.map(logo => (
          <Grid
            key={logo.alt}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: 148,
              px: 3,
              py: 1.5,
              bgcolor: "background.paper",
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2
            }}>
            <img src={logo.src} alt={logo.alt} style={{ ...logoStyle, width: logo.width }} />
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}
